import {DataSourceFilter} from './data-source.filter';
import { Injectable } from "@angular/core";

@Injectable()
export class LocationFilter extends DataSourceFilter {
    public onFilterApplied(data: any, selectedLocation: string): boolean {
        return selectedLocation.toLowerCase() === data.correspondence_address.city.toLowerCase();
    }

    public identifier(): string {
        return 'LocationFilter';
    }
}
